<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ 'AssignArea' | translate }}</h2>
    <button class="btnn close_icon" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="areaFormGroup"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <div class="form_group w_100">
          <mat-label class="required"> {{ 'Areas' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              class="form_control"
              formControlName="areaId"
              multiple
              [placeholder]="'SelectValue' | translate">
              <mat-option [value]="item._id" *ngFor="let item of areaList">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted && areaFormGroup.controls['areaId'].hasError('required')
            ">
            {{ 'Area' | translate }} {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
      </div>
      <div class="submit_btn">
        <button type="submit" class="btnn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
